import React from "react";
import "./MessageBubble.css";

function formatTime(timestamp) {
  if (!timestamp) return "";
  const d = typeof timestamp === "string" ? new Date(timestamp) : timestamp;
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
}

export default function MessageBubble({ role, text, timestamp }) {
  const isUser = role === "user";

  return (
    <div
      className={`message-row ${
        isUser ? "message-row--user" : "message-row--bot"
      }`}
    >
      {!isUser && (
        <div className="message-avatar message-avatar--bot" aria-hidden="true">
          B
        </div>
      )}

      <div className="message-bubble-wrapper">
        <div
          className={`message-bubble ${
            isUser ? "message-bubble--user" : "message-bubble--bot"
          }`}
        >
          {text}
        </div>
        {timestamp && (
          <div className="message-meta">
            <span className="message-time">{formatTime(timestamp)}</span>
          </div>
        )}
      </div>

      {isUser && (
        <div className="message-avatar message-avatar--user" aria-hidden="true">
          U
        </div>
      )}
    </div>
  );
}
